export interface DevToolsState {
    showTargets: boolean;
}

export const TOGGLE_SHOW_TARGETS = "TOGGLE_MAINTENANCE";

export interface toggleShowTargets {
    type: typeof TOGGLE_SHOW_TARGETS;
}

export type DevToolsTypes = toggleShowTargets;